import React, { useState, useEffect } from 'react';
import moment from 'moment';
import {
  Paper,
  CardHeader,
  CardContent,
  Box,
  CircularProgress,
} from '@material-ui/core';
import {
  ResponsiveContainer,
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip as RechartsTooltip
} from 'recharts';

const WorkorderTrendChart = ({ classes, theme, chartData, loading }) => {
  console.log('WorkorderTrendChart', chartData)
  // const [loading, setLoading] = useState(true);
  // const [chartData, setChartData] = useState([]);
  
  // useEffect(() => {
  //   const fetchWorkorderData = async () => {
  //     try {
  //       setLoading(true);
  //       // Replace this with your actual API endpoint
  //       const response = await fetch('/api/workorders/completed-stats');
  //       const data = await response.json();
        
  //       if (data && data.success && data.data) {
  //         setChartData(data.data);
  //       } else {
  //         console.error('Failed to load workorder data:', data.error || 'Unknown error');
  //         // Fallback to empty data
  //         setChartData([]);
  //       }
  //     } catch (error) {
  //       console.error('Error fetching workorder data:', error);
  //       setChartData([]);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };
    
  //   fetchWorkorderData();
  // }, []);
  
  return (
    <Paper className={classes.paper}>
      <CardHeader 
        title="Completed Workorders (30 Days)" 
        className={`${classes.cardHeader} ${classes.infoHeader}`}
      />
      <CardContent>
        {loading ? (
          <Box className={classes.progressWrapper}>
            <CircularProgress />
          </Box>
        ) : (
          <ResponsiveContainer width="100%" height={250}>
            <AreaChart
              data={chartData}
              margin={{
                top: 10,
                right: 30,
                left: 0,
                bottom: 0,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis 
                dataKey="date" 
                tick={{ fontSize: 10 }}
                interval={6}
              />
              <YAxis allowDecimals={false} />
              <RechartsTooltip />
              <Area 
                type="monotone" 
                dataKey="workorders" 
                name="Completed Workorders" 
                stroke={theme.palette.primary.main} 
                fill={theme.palette.primary.light} 
              />
            </AreaChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Paper>
  );
};

export default WorkorderTrendChart;
